<template>
  <!--<ContainerBox title="好感度对话">
    <div class="conversation-info">
      <ElScrollbar wrapStyle="height: 450px; overflow-x: hidden;">
        <template v-for="key in Object.keys(dataSource)">
          <div class="item" :key="key" v-if="dataSource[key].question.hasValue && dataSource[key].question.value">
            <div class="title">
              {{ dataSource[key].question.value }}
            </div>
            <div class="answer">
              <BorderBg />
              <img class="icon" src="@/assets/nikke_imgs/answer100-icon.png" alt="" />
              <span>{{ dataSource[key].answer100.value }}</span>
            </div>
            <div class="answer">
              <BorderBg />
              <img class="icon" src="@/assets/nikke_imgs/answer120-icon.png" alt="" />
              <span>{{ dataSource[key].answer120.value }}</span>
            </div>
          </div>
        </template>
      </ElScrollbar>
    </div>
  </ContainerBox>-->
  <div class="conversation-container">
    <div class="conversation-header">
      <div class="header-l">
        <div class="img-box">
          <img :src="styleData.cover.value" alt="">
        </div>
      </div>
      <div class="header-r">
        <div class="r-dialogue">
          <div class="dialogue-text">
            <img src="@/assets/nikke_imgs/vonversation-rigth-icon.png" alt="">
            好感度对话
          </div>
        </div>
        <div class="search-container">
          <img src="@/assets/nikke_imgs/conversation-search-icon.png" class="search-icon" alt=""/>
          <div class="search-input">
            <el-input placeholder="请输入好感度对话" type="text" v-model="searchKey" @keyup.enter.native="handleSearch"></el-input>
            <img src="@/assets/nikke_imgs/search-close.png" alt="" class="close-search" @click="clearSearch" v-if="searchKey.length > 0">
          </div>
          <div class="search-btn" @click="handleSearch">搜索</div>
        </div>
      </div>
    </div>
    <div class="conversation-group">
      <template v-if="Object.keys(cloneDataSource).length > 0">
        <template v-for="key in Object.keys(cloneDataSource)">
          <div class="conversation-group-list" :key="key"
               v-if="cloneDataSource[key].question.hasValue && cloneDataSource[key].question.value">
            <div class="list-title">
              <img src="@/assets/nikke_imgs/conversation-point-icon.png" alt="">
              <span class="title-text">{{ cloneDataSource[key].question.value }}</span>
            </div>
            <div class="list-dialogue">
              <div class="dialogue-100">
                <img src="@/assets/nikke_imgs/answer100-icon.png" alt="">
                <span>{{ cloneDataSource[key].answer100.value }}</span>
              </div>
              <div class="dialogue-120">
                <img src="@/assets/nikke_imgs/answer120-icon.png" alt="">
                <span>{{ cloneDataSource[key].answer120.value }}</span>
              </div>
            </div>
          </div>
        </template>
      </template>
      <div class="no-data" v-else>
        <img src="@/assets/nikke_imgs/conversation-no-data.png" alt="">
        <p>没有找到当前对话哦~</p>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerBox from "./containerBox.vue";
import BorderBg from "./borderBg.vue";
import {deepClone} from "@/plugins/util";

export default {
  name: "ConversationInfo",
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      },
    },
    styleData: {type: Object, default: () => ({})},
  },
  components: {ContainerBox, BorderBg},
  data() {
    return {
      searchKey: "",
      cloneDataSource: {}
    };
  },
  mounted() {
    this.handleSearch()
  },
  methods: {
    clearSearch() {
      this.searchKey = "";
      this.handleSearch()
    },
    handleSearch() {
      console.log(1111);
      // 使用组件数据
      const data = this.cloneDataSource;

      // 空搜索恢复原始数据
      if (!this.searchKey?.trim()) {
        this.cloneDataSource = deepClone(this.dataSource);
        return;
      }

      const searchTerm = this.searchKey.toLowerCase();
      const result = {};

      // 优化后的搜索逻辑
      Object.keys(data).forEach(key => {
        const {question, answer100, answer120} = data[key];

        const matchQuestion = question?.value?.toLowerCase().includes(searchTerm);
        const matchAnswer100 = answer100?.value?.toLowerCase().includes(searchTerm);
        const matchAnswer120 = answer120?.value?.toLowerCase().includes(searchTerm);

        if (matchQuestion || matchAnswer100 || matchAnswer120) {
          result[key] = data[key];
        }
      });

      // 更新视图
      this.cloneDataSource = result;
    }
  }
};
</script>

<style lang="less" scoped>
.conversation-container {
  width: 660px;
  height: calc(100vh - 120px);
  background: transparent url("~@/assets/nikke_imgs/nav-audio-bg.png") no-repeat;
  background-size: 100% 100%;


  .conversation-header {
    margin: 23px 20px 16px;
    position: sticky;
    top: 23px;
    left: 0;
    display: flex;
    justify-content: space-between;
    height: 88px;
    column-gap: 16px;

    .header-l {
      position: relative;
      width: 95px;
      height: 95px;
      background: url("~@/assets/nikke_imgs/conversation-role-bg.png") no-repeat;
      background-size: 100% 100%;

      .img-box {
        position: absolute;
        right: 0;
        top: 0;
        width: 88px;
        height: 88px;
        clip-path: polygon(0 0,
        100% 0,
        100% calc(100% - 12px),
        calc(100% - 12px) 100%,
        0 100%);

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 12px;
          height: 12px;
          background: #3EAFFE;
          clip-path: polygon(0 0, 100% 0, 0 100%);
        }

        img {
          width: 88px;
          height: 88px;
          object-fit: cover;
          clip-path: polygon(12px 0,
          100% 0,
          100% calc(100% - 12px),
          calc(100% - 12px) 100%,
          0 100%,
          0 12px);
        }
      }


    }

    .header-r {
      flex: 1;

      .r-dialogue {
        width: 100%;
        height: 54px;
        background: url("~@/assets/nikke_imgs/conversation-dialogue-bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;

        .dialogue-text {
          width: 216px;
          height: 27px;
          display: flex;
          align-items: center;
          background: linear-gradient(222deg, #464949 0%, #313131 100%);
          font-family: Noto Sans SC, Noto Sans SC;
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 20px;

          img {
            width: 9px;
            height: 13px;
            margin: 0 13px;
          }
        }
      }

      .search-container {
        display: flex;
        align-items: center;
        height: 42px;
        width: 100%;
        background: #F6F7F8;
        border-bottom: 1px solid #CACDD0;

        img {
          width: 18px;
          height: 18px;
          margin-left: 13px;
        }

        .search-input {
          position: relative;
          display: flex;
          align-items: center;
          flex: 1;

          .close-search {
            position: absolute;
            right: 0;
            width: 20px;
            height: 20px;
            cursor: pointer;
          }
        }

        /deep/ .el-input {
          border: none;

          .el-input__inner {
            border: none;
            background: #F5F6F7;

            &:focus {
              border: none;
              background: #F5F6F7;
            }
          }
        }

        .search-btn {
          width: 68px;
          height: 27px;
          background: url("~@/assets/nikke_imgs/conversation-search-bg.png") no-repeat;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: Noto Sans SC, Noto Sans SC;
          font-weight: 400;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 20px;
          margin-left: 8px;
          cursor: pointer;
        }
      }
    }
  }

  .conversation-group {
    width: 100%;
    height: calc(100% - 147px);
    overflow-y: auto;
    padding: 20px;

    /* 滚动条整体样式 */

    &::-webkit-scrollbar {
      width: 4px;
      height: 16px;
      background-color: transparent;
      margin-right: 3px;
    }

    /* 滚动条轨道样式 */

    &::-webkit-scrollbar-track {
      //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      border-radius: 4px;
      background-color: transparent;
    }

    /* 滚动条滑块样式 */

    &::-webkit-scrollbar-thumb {
      width: 4px;
      height: 62px;
      background: rgba(65, 79, 108, 0.35);
      border-radius: 4px;
    }

    .conversation-group-list {
      width: 100%;
      margin-bottom: 16px;
      //height: 148px;
      background: rgba(255, 255, 255, 0.45);
      box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15), inset 8px -8px 8px 0px #FFFFFF, inset -8px 8px 8px 0px #FFFFFF, -6px 6px 1px 0px rgba(31, 56, 83, 0.1);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #FFFFFF;

      .list-title {
        width: calc(100% - 40px);
        margin: 0 auto;
        height: 40px;
        border-bottom: 1px solid #CACDD0;
        display: flex;
        align-items: center;

        img {
          width: 10px;
          height: 10px;
          margin-right: 10px;
        }
      }

      .list-dialogue {
        width: calc(100% - 40px);
        margin: 14px auto 12px;

        .dialogue-120 {
          margin-top: 11px;
        }

        div {
          width: 100%;
          height: 38px;
          background: url("~@/assets/nikke_imgs/conversation-text-bg.png") no-repeat;
          background-size: 100% 100%;
          display: flex;
          align-items: center;

          img {
            width: 26px;
            height: 22px;
            margin: 0 10px 0 16px;
          }
        }
      }
    }

    .no-data {
      width: 100%;
      height: 187px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-family: Noto Sans SC, Noto Sans SC;
      font-weight: 400;
      font-size: 16px;
      color: rgba(88, 101, 109, 0.5);

      img {
        width: 115px;
        height: 115px;
        margin-bottom: 8px;
      }
    }
  }
}
</style>
